export const API_BASE = process.env.REACT_APP_API_BASE || '/api';
export const SESSION_KEY = 'torverwaltung_user';

export function getStoredUser() {
  try {
    const user = JSON.parse(window.localStorage.getItem(SESSION_KEY));
    return user?.token ? user : null;
  } catch {
    return null;
  }
}

export function storeUser(user) {
  window.localStorage.setItem(SESSION_KEY, JSON.stringify(user));
}

export function clearStoredUser() {
  window.localStorage.removeItem(SESSION_KEY);
}

export function showAppAlert(message, options = {}) {
  window.dispatchEvent(new CustomEvent('dispoboard:modal', {
    detail: {
      type: 'alert',
      title: options.title || 'Hinweis',
      message,
      confirmLabel: options.confirmLabel || 'Schließen',
      danger: Boolean(options.danger),
    },
  }));
}

export function showAppConfirm(message, options = {}) {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent('dispoboard:modal', {
      detail: {
        type: 'confirm',
        title: options.title || 'Bestätigung',
        message,
        confirmLabel: options.confirmLabel || 'Bestätigen',
        cancelLabel: options.cancelLabel || 'Abbrechen',
        danger: Boolean(options.danger),
        resolve,
      },
    }));
  });
}

export async function apiFetch(url, options = {}) {
  const user = getStoredUser();
  const headers = {
    ...(options.headers || {}),
  };

  if (user?.token) {
    headers.Authorization = `Bearer ${user.token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    clearStoredUser();
    window.dispatchEvent(new Event('torverwaltung:unauthorized'));
  }

  if (response.status === 409) {
    const data = await response.clone().json().catch(() => ({}));
    if (data?.code === 'ACCOUNT_IN_USE') {
      window.dispatchEvent(new CustomEvent('torverwaltung:session-conflict', {
        detail: {
          message: data.error || 'Dieses Konto wird bereits an anderer Stelle verwendet.',
          temporary: true,
          retryAfterSeconds: data.retryAfterSeconds,
        },
      }));
      throw new Error(data.error || 'Dieses Konto wird bereits an anderer Stelle verwendet.');
    }
  }

  if (response.status === 403) {
    const data = await response.clone().json().catch(() => ({}));
    if (data?.code === 'LICENSE_LIMIT_REACHED') {
      const message = data.error || 'Du hast das Limit für deine Lizenz erreicht. Erweitere deine Lizenz um mehr hinzuzufügen.';
      showAppAlert(message, {
        title: 'Lizenzlimit erreicht',
        confirmLabel: 'Verstanden',
        danger: true,
      });
      throw new Error(message);
    }
    if (data?.code === 'BOOTSTRAP_SETUP_REQUIRED') {
      const message = data.error || 'Du musst zuerst einen Admin-User anlegen, bevor weitere Daten sichtbar oder bearbeitbar sind.';
      showAppAlert(message, {
        title: 'Admin-User erforderlich',
        confirmLabel: 'Verstanden',
      });
      throw new Error(message);
    }
  }

  return response;
}

export async function requestJson(path, options = {}) {
  const response = await apiFetch(API_BASE + path, options);
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(data?.error || `Anfrage fehlgeschlagen (HTTP ${response.status})`);
    error.code = data?.code || 'HTTP_ERROR'; error.status = response.status;
    throw error;
  }
  if (data === null) throw new Error('Der Server hat keine gültige JSON-Antwort geliefert.');
  if(options.method&&options.method!=='GET'&&!path.endsWith('/preview')&&!data.mutationId)window.dispatchEvent(new CustomEvent('dispoboard:toast',{detail:{message:'Änderungen gespeichert'}}));
  return data;
}
